var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCandyOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4545 1.5C15.1636 1.5 13.1716 2.55768 12 4.33017C10.8284 2.55768 8.83636 1.5 6.54545 1.5C4.81011 1.50207 3.14643 2.20875 1.91935 3.46503C0.692282 4.72131 0.00202124 6.4246 0 8.20126C0 11.4625 1.98545 14.8567 5.90182 18.2878C7.69642 19.8534 9.63491 21.2373 11.6902 22.4202C11.7854 22.4726 11.8919 22.5 12 22.5C12.1081 22.5 12.2146 22.4726 12.3098 22.4202C14.3651 21.2373 16.3036 19.8534 18.0982 18.2878C22.0145 14.8567 24 11.4625 24 8.20126C23.998 6.4246 23.3078 4.72131 22.0806 3.46503C20.8536 2.20875 19.1899 1.50207 17.4545 1.5ZM12 21.0576C10.2098 19.9999 1.30909 14.4244 1.30909 8.20126C1.31053 6.77989 1.86269 5.41715 2.84438 4.41208C3.82608 3.40702 5.15713 2.84173 6.54545 2.84025C8.75782 2.84025 10.6156 4.04983 11.3945 5.99766C11.4439 6.12056 11.5278 6.22569 11.6355 6.29968C11.7433 6.37366 11.8702 6.41316 12 6.41316C12.1298 6.41316 12.2567 6.37366 12.3645 6.29968C12.4722 6.22569 12.5561 6.12056 12.6055 5.99766C13.3844 4.04983 15.2422 2.84025 17.4545 2.84025C18.8429 2.84173 20.174 3.40702 21.1556 4.41208C22.1373 5.41715 22.6894 6.77989 22.6909 8.20126C22.6909 14.4244 13.7902 19.9999 12 21.0576Z",
    fill: "#E42058"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandyOn);
export default __webpack_public_path__ + "static/media/candy-on.2c5665636e6fa4e0ed0ca8a54c92eb07.svg";
export { ForwardRef as ReactComponent };